const buttonFormservQuesList = {
  text: 'Add Action'
};

export default buttonFormservQuesList;
